import script from "./PermissionsModule.vue?vue&type=script&lang=ts&setup=true"
export * from "./PermissionsModule.vue?vue&type=script&lang=ts&setup=true"

import "./PermissionsModule.vue?vue&type=style&index=0&id=e97d202e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e97d202e"]])

export default __exports__